import axios from 'axios';
import { useState, useEffect } from 'react';
import { GET_BLOGS_API, GET_COMPLAINTS } from '../constants/api';

export default function useGetComplaints() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      axios
        .get(GET_COMPLAINTS)
        .then((response) => {
          setData(response.data.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setError(err);
          setLoading(false);
        });
      setLoading(false);
    }
    fetchData();
  }, []);

  return { data, error, loading };
}
